import styled from 'styled-components';

interface StyledProps {
  isVisible: boolean;
}

export const Container = styled.div<StyledProps>`
  position: absolute;
  top: 8px;
  left: 0;
  overflow: hidden;
  z-index: 2;
  display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none !important')};
  width: 100%;
`;

export const Wrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
  }
`;
